import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import StickyButton from "./components/StickyButton";
import BlogPage from "./pages/BlogPage";
import BlogDetail from "./pages/BlogDetail";
import AudioPlayer from "./components/AudioPlayer";
import Gallery from "./pages/Gallery";
import DajiMah from "./pages/DajiMah";
import Gangaji from "./pages/Gangaji";
import Vedpathshala from "./pages/Vedpathshala";
import Goshala from "./pages/Goshala";
import { Parampra } from "./pages/Parampra";
import { VarshikUtsav } from "./pages/VarshikUtsav";
import { Janmotsav } from "./pages/Janmotsav";
import { Chaturmas } from "./pages/Chaturmas";
import { Mahashivratra } from "./pages/Mahashivratra";
import { Nityopasna } from "./pages/Nityopasna";
import { Admission } from "./pages/Admission";
import { Education } from "./pages/Education";
import { WhyGoseva } from "./pages/WhyGoseva";
import { Publication } from "./pages/Publication";
import Admin from "./admin/component/Admin";
import { Outlet } from "react-router-dom";
import AdminDashboardPage from "./admin/component/AdminDashboardPage";
import DonationPage from "./pages/DonationPage";
import Blog from "./admin/component/Blog/Blog";
import AdminEvent from "./admin/component/AdminEvent";
import AdminDonation from "./admin/component/AdminDonation";
import AdminAddEvent from "./admin/component/AdminAddEvent";
import { ToastContainer } from "react-toastify";
import { AddBlog } from "./admin/component/AddBlog/AddBlog";
import AddGallaryPage from "./admin/component/AddGallary/AddGallaryPage";
import AdminContact from "./admin/component/contact/AdminContact";
import AdminGallary from "./admin/component/Gallary/AdminGallary";
import "react-toastify/dist/ReactToastify.css";
import TermsAndCond from "./pages/TermsAndCond";
import Privacy from "./pages/Privacy";
import Return from "./components/Return";
import Refund from "./pages/Refund";
import Shipping from "./pages/Shipping";
import { SevaMandal } from "./pages/SevaMandal";
import { VividhPooja } from "./pages/VividhPooja";
import { SansthanVishayi } from "./pages/SansthanVishayi";
import DonationReceipt from "./components/DonationReceipt";
import DonationDetails from "./pages/DonationDetails";
import ProtectedRoute from "./components/ProtectedRoute";
import VideoGalleryPage from "./pages/VideoGalleryPage";
import AddVideo from "./admin/component/AddVideo/AddVideo";
import VideoGallery from "./admin/component/videogallery/VideoGallery";
import axios from "axios";
import { useEffect, useState } from "react";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import Navbar from "./components/Navbar";
import DayLinks from "./pages/DayLinks";

function PublicLayout({ visitCount }) {
  return (
    <>
      <StickyButton />
      <AudioPlayer />
      <Navbar />
      <div>
        <Outlet /> {/* Nested Page Content */}
      </div>
      <Footer visitCount={visitCount} />
      <BackToTop />
    </>
  );
}

// Admin Layout Component
function AdminLayout() {
  return (
    <div>
      <Outlet /> {/* Renders Nested Admin Routes */}
    </div>
  );
}

export default function App() {
  const url = process.env.REACT_APP_BASE_URL;
  const [visitCount, setVisitCount] = useState(0);

  useEffect(() => {
    if (!url) {
      if (process.env.NODE_ENV === 'development') {
        console.error("REACT_APP_BASE_URL environment variable is not set");
      }
      return;
    }
    axios.post(`${url}/api/visit/add`)
      .then((response) => {
        if (response.data && typeof response.data.count === 'number') {
          setVisitCount(response.data.count);
        }
      })
      .catch((error) => {
        // Silently fail - visitor count is not critical functionality
        if (process.env.NODE_ENV === 'development') {
          console.error("Error updating visit count:", error);
        }
      });
  }, [url]);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route element={<PublicLayout visitCount={visitCount} />}>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/dajimah" element={<DajiMah />} />
          <Route exact path="/event" element={<Events />} />
          <Route path="/gangaji" element={<Gangaji />} />
          <Route path="/receipt" element={<DonationReceipt />} />
          <Route path="/about-vedpathshala" element={<Vedpathshala />} />
          <Route path="/about-goshala" element={<Goshala />} />
          <Route path="/parampra" element={<Parampra />} />
          <Route path="/sansthan" element={<SansthanVishayi />} />
          <Route path="/vividhPooja" element={<VividhPooja />} />
          <Route path="/varshik-utsav" element={<VarshikUtsav />} />
          <Route path="/janmotsav" element={<Janmotsav />} />
          <Route path="/chaturmas" element={<Chaturmas />} />
          <Route path="/mahashivratra" element={<Mahashivratra />} />
          <Route path="/nityopasna" element={<Nityopasna />} />
          <Route path="/admission" element={<Admission />} />
          <Route path="/education" element={<Education />} />
          <Route path="/why-goseva" element={<WhyGoseva />} />
          <Route path="/publication" element={<Publication />} />
          <Route path="/sevaMandal" element={<SevaMandal />} />
          <Route exact path="/contact" element={<Contact />} />
          {/* <Route exact path="/donate/:category" element={<DonationPage />} /> */}
          <Route exact path="/donate" element={<DonationPage />} />
          <Route exact path="/donation-details" element={<DonationDetails />} />
          <Route exact path="/gallery" element={<Gallery />} />
          <Route path="/video-gal" element={<VideoGalleryPage />} />
          <Route path="/dayLink" element={<DayLinks />} />
          <Route path="/blogs" element={<BlogPage />} />
          <Route path="/blogs/:id" element={<BlogDetail />} />

          {/* Policies Routes */}
          <Route path="/terms" element={<TermsAndCond />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/return" element={<Return />}></Route>
          <Route path="/refund" element={<Refund />}></Route>
          <Route path="/shipping" element={<Shipping />}></Route>
        </Route>

        {/* Admin Routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Admin />} /> {/* Admin Login */}
          {/* Dashboard */}
        </Route>
        {/* Protected Admin Routes */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboardPage />
            </ProtectedRoute>
          }
        >
          <Route path="add-blog" element={<AddBlog />} />
          <Route path="add-video" element={<AddVideo />} />
          <Route path="gallery" element={<AdminGallary />} />
          <Route path="videos" element={<VideoGallery />} />
          <Route path="gallery/add-img" element={<AddGallaryPage />} />
          <Route path="contact" element={<AdminContact />} />
          <Route path="blog" element={<Blog />} />
          <Route path="event" element={<AdminEvent />} />
          <Route path="addEvent" element={<AdminAddEvent />} />
          <Route path="donation" element={<AdminDonation />} />
        </Route>

        {/* Fallback Route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <ToastContainer
        position="top-right" // Position to the right
        autoClose={5000} // Auto close after 5 seconds
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </BrowserRouter>
  );
}
